import { FC, useEffect, useState } from 'react';
import { GridColDef, } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATE, I18N, PaymentCategory } from 'src/shared/constants/constants';
import { Card, Tables } from 'src/shared/components/index';
import Grid from '@mui/material/Grid';
import { Dayjs } from 'dayjs';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

interface StatementProps {
  transactions: any[];
  startDate: Dayjs;
  endDate: Dayjs;
}
export const Statement: FC<StatementProps> = ({ transactions, startDate, endDate }) => {
  const { t } = useTranslation(I18N.DEFAULT);
  const [openingBalance, setOpeningBalance] = useState(0);
  const [closingBalance, setClosingBalance] = useState(0);

  useEffect(() => {
    setOpeningBalance(0);
    setClosingBalance(0);
    if (transactions) {
      const size = transactions.length;
      if (size > 0) {
        const opening = transactions[size - 1]?.openingBalance;
        const closing = transactions[0]?.closingBalance;
        setOpeningBalance(opening);
        setClosingBalance(closing);
      }
    }
  }, [transactions]);

  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: 'Date ',
      headerName: t('table.date'),
      sortable: false,
      flex: 1,
      valueGetter: (transactions) => {
        return `${transactions.row.date.split('T')[0]}`;
      },
    },
    {
      field: 'transactionCategory',
      sortable: false,
      headerName: t('table.payment-method'),
      flex: 1,
      valueGetter: (params) => {
        if (params?.row?.paymentCategory === PaymentCategory.DEPOSITE) {
          return `${params?.row?.transactionCategory} (${PaymentCategory.DEPOSITE.toLowerCase()})`;
        } else if (params?.row?.expenceId) {
          return `${params?.row?.transactionCategory}(${PaymentCategory.EXPENCE.toLowerCase()})`;
        } else {
          return params?.row?.transactionCategory;
        }
      }
    },
    {
      field: 'isCredit',
      sortable: false,
      headerName: t('report.statement.credit'),
      flex: 0.7,
      valueGetter: (params) => {
        if (params?.row?.isCredit) {
          return params?.row?.amount;
        } else {
          return '';
        }
      }
    },
    {
      field: 'amount',
      sortable: false,
      headerName: t('report.statement.debit'),
      flex: 0.7,
      valueGetter: (params) => {
        if (params?.row?.expenceId || !params?.row?.isCredit) {
          return params?.row?.amount;
        } else {
          return '';
        }
      }
    },
    {
      field: 'cashClosingBalance',
      sortable: false,
      headerName: t('report.statement.cashbalance'),
      flex: 0.8,

    },
    {
      field: 'bankClosingBalance',
      sortable: false,
      headerName: t('report.statement.bankbalance'),
      flex: 0.9,

    },
    {
      field: 'closingBalance',
      headerName: t('report.statement.balance'),
      sortable: false,
      flex: 1,
    },
  ];
  return (
    <>
      <Card className="mb-24 $orange">
        <Grid container spacing={2} className='mt-1 ml-1 mr-1 $orange'  >
          <Grid item xs={5} md={5} lg={5}>
            <Stack direction="row" spacing={5}>
              <Chip label={`Opening Balance (${startDate.format(DATE_FORMATE.DDMMYY)}):`} color="primary" />
              <Chip label={openingBalance} className="$orange" />
            </Stack>
          </Grid>

          <Grid item xs={6} md={6} lg={6}>
            <Stack direction="row" spacing={5} className="primary">
              <Chip label={`Closing Balance (${endDate.format(DATE_FORMATE.DDMMYY)}):`} color="primary" />
              <Chip label={closingBalance} color="info" />
            </Stack>
          </Grid>
        </Grid>
        <Tables
          rows={transactions}
          columns={columns}
          checkboxSelection={false}
        />
      </Card>
    </>
  )
}
